module.exports = __webpack_public_path__ + "files/trivier.274093359f202f379319482915797cf4.pdf";